import type { MachineSetupRepository } from '../data/machine-setup-repository';
import type { ValidateMachineConfigResponse } from '../types/machine-setup-types';

export class ValidateMachineUseCase {
  constructor(private readonly repository: MachineSetupRepository) {}

  async execute(machineId: number, machineTypeKey: string): Promise<ValidateMachineConfigResponse> {
    if (!machineId || machineId <= 0)
      throw new Error('Valid machine ID is required');
    if (!machineTypeKey)
      throw new Error('Machine type key is required');

    const response = await this.repository.validateMachineConfig(machineId, machineTypeKey);
    if (!response.isSuccess) throw new Error(response.message || 'Failed to validate machine config');
    return response;
  }
}
